import { get } from "../methods";
function getAuthTokenInfo(headers = {}) {
  return get({
    url: `/backend/auth/token/info`,
    headers
  });
}
export {
  getAuthTokenInfo
};
